<div class="grid mb-5">
    <div class="col-12 sm:col-6 align-items-center">
        <p-inputGroup>
            <rc-input 
                id="searchQuickfind" 
                type="text" 
                [classes]="['input-quickfind']"
                placeholder="Quick Search..."
                data-cy="input-quickfind"/> 
                <!-- [control]="filterValue" -->
            <button type="button" pButton icon="pi pi-search" class="btn-quickfind" data-cy="btn-quickfind"></button>
        </p-inputGroup>
    </div>
    <div class="col-12 sm:col-6 align-items-center sm:text-right">
        <rc-generic-button 
            label="Add New Event"
            id="template-button"
            level="secondary"
            size="large"
            (clickHandler)="showAddEventModal = true"
            data-cy="btn-add-event"/>
    </div>
</div>
<p-card>
    <div id="search-column-toggle" class="flex vertical">
        <button [ngClass]="isExpandedView ? 'btn-toggle-expand icon-minimize' : 'btn-toggle-expand icon-expand'" (click)="toggleSelectedLabels()">
        </button>
        <p-multiSelect 
            [group]="true"
            [options]="groupedDisplayColumns" 
            [(ngModel)]="selectedColumns"
            class="multi-select-columns expand-icon"
            scrollHeight="300px" 
            display="chip" 
            styleClass="w-full md:w-80"
            [maxSelectedLabels]="maxSelected"
            [selectedItemsLabel]="'{0} items selected'"
            (onChange)="reorderColumns($event)"
            placeholder="Choose Columns" 
            id="multi-select-columns"
            data-cy="multi-select-columns"
            [ngClass]="{'expanded': isExpandedView, 'collapsed': !isExpandedView}">
        </p-multiSelect>
    </div>

    <div class="search-actions grid py-2">
        <div class="col text-left">
            
            <p-button
                label="Selected"
                icon="pi pi-angle-down"
                iconPos="right"
                severity="secondary"
                [disabled]="numberOfItemsSelected === 0"
                (onClick)="selectMenu.toggle($event)"
                styleClass="mr-1 my-1"
                data-cy="btn-selected"></p-button>
            <p-menu #selectMenu [popup]="true" [model]="selectedOptions"></p-menu>

            <p-button 
                label="Export" 
                icon="fa-sharp fa-light fa-download" 
                (onClick)="onExportToExcel()" 
                id="button-export" 
                severity="secondary"
                [outlined]="true" 
                styleClass="my-1" 
                [disabled]="!hasResults"
                class="ml-0"
                data-cy="btn-export"></p-button>

        </div>
        <div class="top-paginator" *ngIf="hasResults && (data.length > pagingModel.maxResults)"> 
            <div class="mb-3">
                <p-button 
                    type="button" 
                    icon="pi pi-chevron-left" 
                    styleClass="p-button-text mr-1 grey-text-button"
                    (onClick)="pageBack()"
                    data-cy="btn-back"/>
                
                <p-button 
                    type="button" 
                    icon="pi pi-chevron-right" 
                    styleClass="p-button-text ml-1 grey-text-button"
                    (onClick)="pageForward()"
                    data-cy="btn-forward"/>
            </div>
        </div>
        <div class="col text-right">
            <!-- 
            SCROLLING SEARCH MENU ACTIVATING BUTTON -- FUTURE ADD
            <rc-generic-button 
                label=""
                id="button-filter"
                iconImg="filter"
                level="secondary"   
                borderStyle="outline"
                (click)="scrollToTop()" 
                [classes]="['mr-1 my-1 white-button']" /> -->
            <rc-generic-button 
                label="Clear All"
                id="button-clear-filters"
                iconImg="clear-filter"
                borderStyle="outline"
                (click)="resetFilters()" 
                [disabled]="!hasFilters"
                [classes]="['my-1']"
                data-cy="btn-clear" />
            <rc-generic-button 
                label="Search"
                id="button-search"
                iconImg="search"
                (click)="onSearch()"
                [classes]="['my-1 ml-1']"
                data-cy="btn-search"/>
        </div>
    </div>

    <div style="width: 100%; position: relative; min-height: 22rem;">
        <p-table 
            #resultstable 
            selectionMode="multiple"
            scrollHeight="flex" 
            filter="false"
            styleClass="rc-datatable-outlined first-col-border last-col-border"
            [rows]="pagingModel.maxResults"
            [(selection)]="selectedColumns"
            [columns]="selectedColumns" 
            [value]="data"
            [exportHeader]="'customExportHeader'"
            [paginator]="!showLoading && hasResults && data.length > pagingModel.maxResults" 
            [sortField]="pagingModel.sortField" 
            [sortOrder]="pagingModel.sortAsc" 
            [rowsPerPageOptions]="[10, 25, 50, 100]"
            (onPage)="pageChange($event)" 
            [scrollable]="true"
            [reorderableColumns]="true"
            dataKey="eventID"
            data-cy="table-data"
            id="table-data">

            <ng-template pTemplate="caption" style="min-height: 300px"></ng-template>
            <ng-template #defaultTableHeaderTemplate>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pFrozenColumn>
                        </th>
                        <th 
                            *ngFor="let col of columns"  pReorderableColumn
                            pSortableColumn={{col.columnName}} id="column-{{col.columnName}}"
                            style="vertical-align: top;" 
                            nowrap
                            >
                            <div class="sortable-title">    
                                <div class="column-title" [textContent]="col.displayColumn"></div>
                                <p-sortIcon [field]="col.columnName" id="sort-icon-{{col.columnName}}" style="cursor: pointer;"
                                />
                            </div>
                        </th>
                        <th alignFrozen="right" pFrozenColumn class="text-center">
                            <div class="column-title">Actions</div>
                        </th>
                    </tr>
                    <tr>
                        <th pFrozenColumn>  
                            <p-checkbox 
                                id="checkbox-select-all" 
                                [binary]="true" 
                                [(ngModel)]="allItemsChecked"
                                (click)="checkAll()"
                                data-cy="checkbox-select-all"/>
                        </th>
                        <th *ngFor="let col of columns" pReorderableColumn class="filter">
                            <rc-table-filter [filterModel]="col.filterModel" (modelChange)="col.filterModel = $event" />
                        </th>
                        <th alignFrozen="right" pFrozenColumn [frozen]="balanceFrozen">
                        </th>
                    </tr>
                    
                    <!-- <tr *ngIf="(!hasResults || showLoading)">
                        <td [attr.colspan]="resultsColspan" ngClass="medium loader-wrapper">
                            <div *ngIf="showLoading">
                                <rc-loading-spinner></rc-loading-spinner>
                            </div>
                            @if ((showLoading === false) && (searchPerformed === true) && (!hasResults)) {
                            <div style="width: 100%; min-height: 50px; margin: 20px auto; padding: 5% 5%; text-align: center;"> 
                                <h3>No Results Available for the Search Performed.</h3>
                            </div>
                            }
                        </td>
                    </tr> -->
                    
                </ng-template>
            </ng-template> 

            <!-- [(selection)]="selectedColumns" -->
            <ng-container [ngTemplateOutlet]="defaultTableHeaderTemplate">
            </ng-container>
            
            <ng-template pTemplate="body" let-item let-index="rowIndex" #defaultTableBodyTemplate>

                <tr *ngIf="!showLoading && hasResults"><!-- [class]="getIsChecked(item, itemsChecked) ? 'selected' : ''" -->
                    <td pFrozenColumn>
                        <p-checkbox 
                            id="checkbox-select-all" 
                            [binary]="true" 
                            [(ngModel)]="item.isChecked"
                            (click)="check(item)"
                            data-cy="checkbox-select-all"/>
                    </td>
                    <td *ngFor="let col of selectedColumns">
                        <span *ngIf="col.columnName === 'Status'">
                            <p-tag [value]="getDisplayValue(item, col)"
                                [severity]="getDisplayValue(item, col) === 'Active' ? 'success' : 'warning'">
                            </p-tag>
                        </span>
                        <a [routerLink]="'/vortex/fundraising-activity/event/'+ item.EventID" *ngIf="col.columnName === 'EventCode'" [textContent]="getDisplayValue(item, col)"></a>
                        <span [textContent]="getDisplayValue(item, col)" *ngIf="col.columnName !== 'Status' && col.columnName !== 'EventCode'"></span>
                    </td>
                    <td alignFrozen="right" pFrozenColumn [frozen]="balanceFrozen"
                        class="frozen-col flex"
                        style="white-space: nowrap; padding: 1rem 0.5rem;" 
                        class="text-center"
                        >
                        <rc-generic-button 
                            label="Edit"
                            iconImg="cog"
                            iconColor="teal-light"
                            [isIconOnly]="true"
                            [classes]="['mx-1']"  
                            [href]="'/vortex/fundraising-activity/event/'+ item.EventID"
                            data-cy="btn-edit"
                            />
                        <rc-generic-button 
                            label="Delete"
                            iconImg="trash"
                            iconColor="red-light"
                            [isIconOnly]="true" 
                            [classes]="['mx-1']"  
                            (clickHandler)="openActionDialog(item,'Delete')"
                            data-cy="btn-delete"
                            />
                    </td>
                </tr>

            </ng-template>
                
        </p-table>
            
        <div *ngIf="showLoading || !hasResults" ngClass="medium loader-wrapper">
            <div *ngIf="showLoading">
                <rc-loading-spinner></rc-loading-spinner>
            </div>
            @if ((showLoading === false) && (searchPerformed === true) && (!hasResults)) {
            <div class="no-data-message"> 
                No results found. Please review your filters and try again.
            </div>
            }
        </div>

        <div class="search-actions grid py-2" style="width: 101%" *ngIf="hasResults">

            <div class="col text-left flex">

            <p-button
                label="Selected"
                icon="pi pi-angle-down"
                iconPos="right"
                severity="secondary"
                [disabled]="numberOfItemsSelected === 0"
                (onClick)="selectMenu.toggle($event)"
                styleClass="mr-1 my-1"
                data-cy="btn-selected"></p-button>
            
            <p-button
                [disabled]="!hasResults"
                label="Export"
                icon="fa-sharp fa-light fa-download"
                id="button-export"
                [outlined]="true"
                styleClass="my-1"
                severity="secondary"
                (onClick)="onExportToExcel()"
                class="ml-0"
                data-cy="btn-export"></p-button>

            </div>
        </div>
    </div>
    
</p-card>

<div class="dialog-footer button-group text-right mt-3" *ngIf="showInDialog">

    <button 
        pButton
        label="Cancel"
        class="p-button-secondary"
        (click)="onCancel()"
        data-cy="btn-cancel"></button>

</div>

<p-toast></p-toast>

<!-- ACTIONS CONFIRM dialog -->

<p-dialog 
    [(visible)]="showConfirmModal" 
    [modal]="true" 
    styleClass="p-confirm-dialog"
    [closable]="false" 
    header="{{confirmAction}} {{numberOfItemsSelected === 1 ? 'event' : 'events'}}"
    #actionModal>

    <div>
        <p>Please confirm you would like to {{confirmAction?.toLowerCase()}} your selected items:</p>
        <p class="label">{{selectedListString()}}</p>

        <p *ngIf="confirmAction === 'Delete'" class="font-bold">
            {{numberOfItemsSelected > 1 ? "These events" : "This event"}} will no longer be associated with any expenses or donations.
        </p>
        <!-- {{lastClicked|json}} -->
    </div>
    
    <ng-template pTemplate="footer">
        <rc-generic-button label="Cancel" (click)="showConfirmModal = false" borderStyle="outline" data-cy="btn-cancel"/>
        <rc-generic-button label={{confirmAction}} (clickHandler)="performSelectedOperation()" />
    </ng-template>

</p-dialog>

<!-- Add/Edit event modal -->
<app-event-modal 
    [(visible)]="showAddEventModal"
    [eventData]="addEventModel"
    [eventTypes]="eventTypes"
    (onCancel)="confirmAction = null; showAddEventModal = false"
    
    ></app-event-modal>
<!-- <pre>
    {{selectedColumns|json}}
</pre> -->